import omit from 'lodash/omit';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class ButtonComponent extends React.PureComponent {
  get type () {
    if (this.props.submit) {
      return 'submit';
    }

    if (this.props.reset) {
      return 'reset';
    }

    return 'button';
  }

  render () {
    const props = omit(this.props, [
      'submit', 'reset', 'className'
    ]);

    const className = classNames(
      'main-button flex-grow',
      this.props.className,

      {
        'main-button--disable': this.props.disabled
      }
    );

    return (
      <button
        {...props}
        type={this.type}
        className={className}
      />
    );
  }
}

ButtonComponent.propTypes = {
  reset: PropTypes.bool,
  submit: PropTypes.bool,
  disabled: PropTypes.bool,

  className: PropTypes.string
};

ButtonComponent.defaultProps = {
  reset: false,
  submit: false,
  disabled: false,

  className: ''
};

export default ButtonComponent;
